import React, { useContext, useState } from "react";
import { getData } from "../feathers";
import { SocketErrorProvider } from "./SocketErrorContext";
import * as Sentry from "@sentry/react";
import { getEnumValueByKey } from "../Enums/GlobalFunctions";
import { ENUM_ROLES } from "../Enums/ENUM_ROLES";

const TabViewsIndexContext = React.createContext();
const TabViewsIndexUpdateContext = React.createContext();
const CurrentUserContext = React.createContext();
const CurrentUserUpdateContext = React.createContext();
const CurrentUserHasRoleContext = React.createContext();
const CurrentUserIsSuperAdminContext = React.createContext();
const CurrentUserIsAdminContext = React.createContext();
const CurrentUserIsMainMonitorContext = React.createContext();
const CurrentUserIsReaderContext = React.createContext();
const UserSwitchModeContext = React.createContext();
const UserSwitchModeUpdateContext = React.createContext();

export function useTabViewsIndex() {
	return useContext(TabViewsIndexContext);
}
export function useTabViewsIndexUpdate() {
	return useContext(TabViewsIndexUpdateContext);
}
export function useCurrentUser() {
	return useContext(CurrentUserContext);
}
export function useCurrentUserHasRole() {
	return useContext(CurrentUserHasRoleContext);
}
export function useCurrentUserUpdate() {
	return useContext(CurrentUserUpdateContext);
}
export function useCurrentUserIsSuperAdmin() {
	return useContext(CurrentUserIsSuperAdminContext);
}
export function useCurrentUserIsAdmin() {
	return useContext(CurrentUserIsAdminContext);
}
export function useCurrentUserIsMainMonitor() {
	return useContext(CurrentUserIsMainMonitorContext);
}
export function useCurrentUserIsReader() {
	return useContext(CurrentUserIsReaderContext);
}
export function useUserSwitchMode() {
	return useContext(UserSwitchModeContext);
}
export function useUserSwitchModeUpdate() {
	return useContext(UserSwitchModeUpdateContext);
}

export function CurrentUserProvider({ children }) {
	const [currentUser, setCurrentUser] = useState(null);
	const [roles, setRoles] = useState([]);
	const [tabViewsIndex, setTabViewIndex] = useState({});
	const [isSuperAdmin, setIsSuperAdmin] = useState(false);
	const [isAdmin, setIsAdmin] = useState(false);
	const [isMainMonitor, setIsMainMonitor] = useState(false);
	const [isReader, setIsReader] = useState(false);
	const [switchedUser, setSwitchedUser] = useState(null);
	const [isSwitchMode, setIsSwitchMode] = useState(false);

	const hasRole = (role) => {
		return roles.includes(role)
	}

	async function setUser(user) {
		if (user) {
			const { permissions, email, isAdmin, username, roles } = user;
			setIsSuperAdmin(user.isAdmin === 1);
			setIsAdmin(permissions === 'ADMIN');
			setIsReader(permissions === 'READER');
			setIsMainMonitor(username === 'Hauptwache')
			setRoles((roles || '').split(',').map((e) => getEnumValueByKey(ENUM_ROLES, e?.trim())))
			Sentry.setUser({ email });
			Sentry.setTag('permission', permissions);
		} else {
			setTabViewIndex(null);
			setIsSuperAdmin(false);
			setIsAdmin(false);
			setIsReader(true);
			setRoles([])
			Sentry.setUser(null);
			Sentry.setTag('permission', '');
		}
		setCurrentUser(user);
	}

	async function setSwitchMode(switchUser) {
		await getData('users', currentUser.id).then((user) => {
			if (!user.isAdmin || !switchUser) {
				setIsSwitchMode(false);
				setSwitchedUser(null);
				setIsAdmin(currentUser.permissions === 'ADMIN');
				setIsReader(currentUser.permissions === 'READER');
			} else {
				if (switchUser) {
					switchUser.permissions = 'READER';
					switchUser.isSwitchedUser = true;
				}
				setIsSwitchMode(true);
				setSwitchedUser(switchUser);
				setIsAdmin(switchUser.permissions === 'ADMIN');
				setIsReader(switchUser.permissions === 'READER');
			}

		})
	}

	return (
		<TabViewsIndexUpdateContext.Provider value={setTabViewIndex}>
			<TabViewsIndexContext.Provider value={tabViewsIndex}>
				<CurrentUserHasRoleContext.Provider value={hasRole}>
					<CurrentUserContext.Provider value={switchedUser || currentUser}>
						<CurrentUserIsSuperAdminContext.Provider value={isSuperAdmin || isSwitchMode}>
							<CurrentUserIsAdminContext.Provider value={isAdmin}>
								<CurrentUserIsMainMonitorContext.Provider value={isMainMonitor}>
									<CurrentUserIsReaderContext.Provider value={isReader}>
										<CurrentUserUpdateContext.Provider value={setUser}>
											<UserSwitchModeContext.Provider value={isSwitchMode}>
												<UserSwitchModeUpdateContext.Provider value={setSwitchMode}>
													<SocketErrorProvider>
														{children}
													</SocketErrorProvider>
												</UserSwitchModeUpdateContext.Provider>
											</UserSwitchModeContext.Provider>
										</CurrentUserUpdateContext.Provider>
									</CurrentUserIsReaderContext.Provider>
								</CurrentUserIsMainMonitorContext.Provider>
							</CurrentUserIsAdminContext.Provider>
						</CurrentUserIsSuperAdminContext.Provider>
					</CurrentUserContext.Provider>
				</CurrentUserHasRoleContext.Provider>
			</TabViewsIndexContext.Provider>
		</TabViewsIndexUpdateContext.Provider>
	)
}